export function convertToEnumValue<T extends Record<string, string>>(
  e: T,
  v: string
): T[keyof T] | undefined {
  return (Object.values(e) as string[]).includes(v)
    ? (v as T[keyof T])
    : undefined;
}
